<div class="login-container">
    <div class="col s-100 panel-left">
        <div class="banner">
            <img class="bg" src="assets/brand-logo.png">
        </div>
    </div>
    <div class="col s-100 panel-right">
        <div class="form-wrapper animate fade-in">
            <h1 class="signup-heading">Register</h1>
            <p class="signup-sub">Create your OneCG account to get started.</p>

            <form class="form" (submit)="signup($event)" [formGroup]="signUpForm">
                <app-alert *ngIf="showError" [type]="'danger'">
                    <div content>{{showError}}</div>
                </app-alert>
                <app-alert *ngIf="showSuccess">
                    <div content>Account successfully created</div>
                </app-alert>

                <div class="name-row">
                    <div class="field-group">
                        <label class="field-label">FIRST NAME</label>
                        <app-form-input [label]="''" [error]="signUpForm.controls.firstName">
                            <input type="text" formControlName="firstName">
                        </app-form-input>
                    </div>
                    <div class="field-group">
                        <label class="field-label">LAST NAME</label>
                        <app-form-input [label]="''" [error]="signUpForm.controls.lastName">
                            <input type="text" formControlName="lastName">
                        </app-form-input>
                    </div>
                </div>

                <div class="field-group">
                    <label class="field-label">EMAIL</label>
                    <app-form-input [label]="''" [error]="signUpForm.controls.email">
                        <input type="email" formControlName="email">
                    </app-form-input>
                </div>

                <div class="field-group">
                    <label class="field-label">PASSWORD</label>
                    <div class="pw-input-wrapper">
                        <mat-icon class="pw-toggle" (click)="togglePasswordVisibility()" style="cursor: pointer;">{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        <app-form-input [label]="''" [error]="signUpForm.controls.password">
                            <input type="{{ hidePassword ? 'password' : 'text' }}" formControlName="password" autocomplete="off">
                        </app-form-input>
                    </div>
                    <div *ngIf="signUpForm.get('password').hasError('pattern')" class="field-hint">
                        Minimum 8 characters, with at least 1 number, 1 capital letter and 1 special character.
                    </div>
                </div>

                <div class="field-group">
                    <label class="field-label">CONFIRM PASSWORD</label>
                    <div class="pw-input-wrapper">
                        <mat-icon class="pw-toggle" (click)="toggleConfirmPasswordVisibility()" style="cursor: pointer;">{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        <app-form-input [label]="''" [error]="signUpForm.controls.confirmPassword">
                            <input type="{{ hideConfirmPassword ? 'password' : 'text' }}" formControlName="confirmPassword" autocomplete="off">
                        </app-form-input>
                    </div>
                </div>
                <div class="terms-check">
                    <app-form-checkbox [value]="signUpForm.value.acceptTerms" (change)="setTerms($event)">
                    </app-form-checkbox>
                    <div class="plabel">I accept the <a href="https://quicktest.ai/terms-and-conditions/" target="_BLANK">Terms of Service</a> and have read the <a href="https://quicktest.ai/privacy-policy-2/" target="_BLANK">Privacy Statement</a>.</div>
                </div>

                <button class="hide">signup</button>
                <button type="submit" class="btn-signup">Register</button>

                <div class="signup-login-link">
                    Already have an account? <a routerLink="/login">Sign In</a>
                </div>
            </form>
        </div>
    </div>
</div>
